module.exports = __webpack_public_path__ + "static/media/sonicscale-1.96c11f15.jpg";